export default class Faq {
    constructor() {
        this.sections = document.querySelectorAll('.component-faq');
        this.ready();
    }

    ready() {
        this.sections.forEach(section => {
            const allItems = section.querySelectorAll('.faq-item');

            allItems.forEach(item => {
                const button = item.querySelector('button.title');
                const content = item.querySelector('.pergunta');

                if (!button || !content) return;

                button.addEventListener('click', () => {
                    const isExpanded = button.getAttribute('aria-expanded') === 'true';

                    if (isExpanded) {
                        // Fechar
                        button.setAttribute('aria-expanded', 'false');
                        content.style.maxHeight = null;
                        setTimeout(() => {
                            content.hidden = true;
                        }, 300);
                        item.classList.remove('active');
                    } else {
                        // Abrir
                        button.setAttribute('aria-expanded', 'true');
                        content.hidden = false;
                        content.style.maxHeight = content.scrollHeight + 'px';
                        item.classList.add('active');
                    }
                });
            });
        });
    }
}

if (document.querySelector('.component-faq')) {
    new Faq();
}
